export const environment = {
    production: false,
    baseHref: '/',
    domain_url: '/',
    api_url: 'https://drci5ihael.execute-api.us-west-1.amazonaws.com/dev/',
    slug:"development",
    decisiondoc_rapid_response_access_url:'https://wfr9bu9th2.execute-api.us-east-1.amazonaws.com/dev/'
};
